<ng-container *ngIf="!isLoading">
  <div class="img-box">
    <img [src]="data.image  + '?width=549&format=webp'"  class="w-100 h-auto" alt="">
  </div>

  <h4 class="title">{{ data.title }}</h4>

  <div class="info">
    <div class="author">{{ data.author }}</div>
    <div class="date">{{ data.date | date }}</div>
  </div>

  <div class="text">{{ data.description }}</div>
  <a [href]="data.link" class="more-btn btn-md" mat-flat-button color="primary" target="_blank">{{openArticleBtnText}}</a>

  <div *ngIf="data.unitName" class="unit-name">
    {{ data.unitName }}
  </div>
  
</ng-container>

<ng-container *ngIf="isLoading">
  <div class="img-box">
    <app-skeleton [height]="260"/>
  </div>

  <app-skeleton class="title" [type]="'text'" [symbolsCount]="20"/>

  <div class="info">
    <app-skeleton [type]="'text'" [symbolsCount]="20"/>
  </div>

  <app-skeleton class="text" [type]="'text'" [symbolsCount]="100"/>

  <app-skeleton [height]="44" [width]="140"/>
</ng-container>